import axios from 'axios';
import store from '../../store';
import { SessionExpiredAndClearStore } from '../../actions/auth';

const bffcli = axios.create({ baseURL: '/api' });
const { dispatch } = store;
bffcli.interceptors.request.use(config => {
  console.log(`[BFF CALL] ${config.method} ${config.url} ...`);
  return config;
});

bffcli.interceptors.response.use(
  response => {
    console.log(
      `[BFF CALL] [${response.status}] ${response.config} ${response.config.url}`
    );
    return response;
  },
  error => {
    if (
      error.response.status === 401 &&
      error.response.headers['issessionvalid'] &&
      error.response.headers['issessionvalid'] === 'false'
    ) {
      console.log('response.config.url', error.response.config.url);
      console.log('logoutClearStore');
      dispatch(SessionExpiredAndClearStore());
    }
    throw error;
  }
);

export default bffcli;
